import { ElementRef, QueryList } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, map, startWith, switchMap } from 'rxjs/operators';

/**
 * Get stream, that emit every time, when element resize
 *
 * @param element
 * @param emitFirst - make initial emit with element
 */
export function onElementResize(
  element: HTMLElement,
  emitFirst = false,
): Observable<HTMLElement> {
  const resize = new Observable<HTMLElement>(observer => {
    const resizeObserver = new ResizeObserver(() => {
      observer.next(element);
    });
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  });
  return emitFirst ? resize.pipe(startWith(element)) : resize;
}

/**
 * Get events stream of resize events from QueryList
 *
 * @param queryList
 * @param emitFirst - make initial emit with element
 */
export function onQueryListResize<T extends HTMLElement>(
  queryList: QueryList<ElementRef<T>>,
  emitFirst = false,
): Observable<T> {
  return queryList.changes.pipe(
    startWith(queryList),
    map((filterContainer: QueryList<ElementRef<T>>) => filterContainer.first),
    filter(ref => Boolean(ref)),
    map(ref => ref.nativeElement),
    switchMap(element => onElementResize(element, emitFirst)),
  ) as Observable<T>;
}
